import axios from 'axios';

export const log = (message, level = '') => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
  const path = 'api/log';
  let url = `${baseUrl}/${path}${level ? `/${level}` : ''}`;
  return axios.post(url, { message });
};

export const LogLevels = {
  Error: 'Error',
  Warn: 'Warn',
  Trace: 'Trace',
  Info: 'Info',
  Debug: 'Debug',
};